import type { ReactNode } from "react";

interface ProfileStatCardProps {
  icon: ReactNode;
  label: string;
  suffix: string;
  value: number | string | null;
}

export const ProfileStatCard = ({
  icon,
  label,
  value,
  suffix,
}: ProfileStatCardProps) => {
  return (
    <div className="min-h-[104px] rounded-[18px] bg-white/70 px-5 py-5 shadow-[0_14px_30px_rgba(22,24,28,0.026),inset_0_0_0_1px_rgba(238,240,237,0.66),inset_0_1px_0_rgba(255,255,255,0.9)]">
      <div className="flex items-center gap-3 ">
        <span className="flex size-[22px] items-center justify-center text-[#A5A7AA]">
          {icon}
        </span>
        <span className="text-[14px] font-bold uppercase tracking-[0.05em] text-[#A5A7AA]">
          {label}
        </span>
      </div>
      <div className="mt-5 flex items-end gap-2">
        <span className="text-[41px] font-medium leading-none tracking-normal text-[#C9E900]">
          {value ?? "—"}
        </span>
        <span className="pb-1.5 text-[16px] font-bold leading-none text-[#C9E900]">
          {suffix}
        </span>
      </div>
    </div>
  );
};
